var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-theme-alpine",staticStyle:{"height":"400px","width":"100%"}},[_c('ag-grid-vue',{attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"defaultColDef":_vm.defaultColDef,"domLayout":'autoHeight',"gridOptions":_vm.gridOptions,"pagination":true,"paginationPageSize":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }